module.exports = __webpack_public_path__ + "logo-weebox.png?1dbb6ee3e83feb8eefc4a6af534fc893";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-weebox.png
// module id = 43
// module chunks = 0